import { render, staticRenderFns } from "./Categorieen.vue?vue&type=template&id=0b56dee4"
import script from "./Categorieen.vue?vue&type=script&lang=js"
export * from "./Categorieen.vue?vue&type=script&lang=js"
import style0 from "./Categorieen.vue?vue&type=style&index=0&id=0b56dee4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports